<p>confirm-dialog works!</p>
